import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-topbar-search-results-makes",
  templateUrl: "./topbar-search-results-makes.component.html",
  styleUrls: ["./topbar-search-results-makes.component.scss"],
})
export class TopbarSearchResultsMakesComponent {
  @Input() primaryType: string;
  @Input() cityState: boolean;
  @Input() makes: any[];
  @Input() location: any;

  showMakes: boolean = false;

  constructor() {}

  getMakeRouterUrl(make: any): string[] {
    return ["/equipment-rentals", this.primaryType, this.location, make];
  }
}
